// Volanlı tema — ana JS modülü
// Bütçe: < 16 KB gzipped (Shopify resmi limit).
// Sadece kritik davranış: header sticky, cart count refresh, mobile menu.
// Ağır component'ler (gallery, cart-drawer, predictive-search) ayrı module'ler, lazy import.

(() => {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion) document.documentElement.dataset.reducedMotion = 'true';

  /* Header: scroll-down gizle, scroll-up göster */
  const header = document.querySelector('[data-header]');
  if (header) {
    let lastY = window.scrollY;
    let ticking = false;
    const onScroll = () => {
      const y = window.scrollY;
      const goingDown = y > lastY && y > 80;
      header.dataset.hidden = goingDown ? 'true' : 'false';
      lastY = y;
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  }

  /* Menü dropdown (non-modal <dialog>) — hamburger altında, şeffaf, toggle */
  const menu = document.querySelector('[data-mobile-menu]');
  if (menu) {
    const openBtn = document.querySelector('[data-menu-open]');
    const closeBtn = menu.querySelector('[data-menu-close]');

    const openMenu = () => {
      menu.show();
      openBtn?.setAttribute('aria-expanded', 'true');
    };
    const closeMenu = () => {
      if (menu.open) menu.close();
    };
    const toggleMenu = () => (menu.open ? closeMenu() : openMenu());

    openBtn?.addEventListener('click', toggleMenu);
    closeBtn?.addEventListener('click', closeMenu);
    menu.addEventListener('close', () => openBtn?.setAttribute('aria-expanded', 'false'));

    // Dışarı tıkla → kapat
    document.addEventListener('click', (e) => {
      if (!menu.open) return;
      if (menu.contains(e.target)) return;
      if (openBtn && openBtn.contains(e.target)) return;
      closeMenu();
    });
    // ESC → kapat (non-modal'da otomatik değil)
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && menu.open) closeMenu();
    });
  }

  /* UTM cookie capture (ACTMS atfı için, cart.attributes'a Faz 1.3'te aktarılır) */
  const captureUTM = () => {
    const params = new URLSearchParams(window.location.search);
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    let captured = false;
    utmKeys.forEach((k) => {
      const v = params.get(k);
      if (v) {
        document.cookie = `${k}=${encodeURIComponent(v)}; max-age=2592000; path=/; SameSite=Lax`;
        captured = true;
      }
    });
    if (captured) sessionStorage.setItem('utm_captured', '1');
  };
  captureUTM();

  /* Density toggle (collection + search 1-col / 2-col) */
  const densityGroup = document.querySelector('[data-density-toggle]');
  const densityTarget = document.querySelector('[data-density-target]');
  if (densityGroup && densityTarget) {
    const initial = localStorage.getItem('volanli_density') || 'compact';
    const apply = (d) => {
      densityTarget.dataset.density = d;
      densityGroup.querySelectorAll('[data-density]').forEach((btn) => {
        btn.setAttribute('aria-pressed', btn.dataset.density === d ? 'true' : 'false');
      });
    };
    apply(initial);
    densityGroup.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-density]');
      if (!btn) return;
      const d = btn.dataset.density;
      apply(d);
      localStorage.setItem('volanli_density', d);
    });
  }

  /* Cart count refresh (Section Rendering API döndüğünde JS bu fonksiyonu çağırır) */
  window.refreshCartBubble = (sections) => {
    if (!sections) return;
    const bubble = document.querySelector('[data-cart-bubble]');
    if (!bubble || !sections['cart-icon-bubble']) return;
    // Section Rendering API yanıtı her zaman wrapper içerir; içeriği çıkar
    const tmp = document.createElement('div');
    tmp.innerHTML = sections['cart-icon-bubble'];
    const newBubble = tmp.querySelector('[data-cart-bubble]');
    if (newBubble) bubble.replaceWith(newBubble);
  };
})();
